import { render, staticRenderFns } from "./comparison-banner.vue?vue&type=template&id=151af30b&"
import script from "./comparison-banner.vue?vue&type=script&lang=js&"
export * from "./comparison-banner.vue?vue&type=script&lang=js&"
import style0 from "./comparison-banner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports